import { render, staticRenderFns } from "./TemplateDetailedPreview.vue?vue&type=template&id=70d8a388&scoped=true&"
import script from "./TemplateDetailedPreview.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailedPreview.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailedPreview.vue?vue&type=style&index=0&id=70d8a388&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8a388",
  null
  
)

export default component.exports